import { AllotmentFormComponent } from './components/allotment/allotment-form/allotment-form.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './../shared/services/auth-guard.service';
import { AdminAuthGuard } from './../shared/services/admin-auth-guard.service';

import { ManagementComponent } from './management.component';
import { HomeComponent } from './components/home/home.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { TransferRequestListComponent } from './components/transfer-request/transfer-request-list/transfer-request-list.component';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';

import { ProfileFormComponent } from './components/employee/profile-form/profile-form.component';
import { ProfileContactFormComponent } from './components/employee/profile-contact-form/profile-contact-form.component';

import { ServiceBookListComponent } from './components/employee/service-book/service-book-list/service-book-list.component';
import { ServiceBookFormComponent } from './components/employee/service-book/service-book-form/service-book-form.component';
import { PresentPlaceFormComponent } from './components/employee/service-book/present-place-form/present-place-form.component';
import { AllotmentProcessComponent } from './components/allotment/allotment-process/allotment-process.component';
import { AllotmentListComponent } from './components/allotment/allotment-list/allotment-list.component';
import { ExportExcelComponent } from './components/allotment/export-excel/export-excel.component';
import { TransferOrderListComponent } from './components/transfer-order/transfer-order-list/transfer-order-list.component';
import { TransferOrderFormComponent } from './components/transfer-order/transfer-order-form/transfer-order-form.component';
import { TransferOrderExportComponent } from './components/transfer-order/transfer-order-export/transfer-order-export.component';
import { ViewEmployeeProfileComponent } from './components/employee/view-employee-profile/view-employee-profile.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: "Admin" },
    component: ManagementComponent,
    canActivate: [AuthGuard, AdminAuthGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'Home' },
        component: HomeComponent
      },
      {
        path: 'employees',
        data: { breadcrumb: "Employees" },
        children: [
          { path: '', component: EmployeeListComponent, data: { breadcrumb: "Employees" } },
          { path: 'edit/:id/:financialYearId', component: ProfileFormComponent, data: { breadcrumb: "Edit Employee Profile" } },
          { path: 'edit-contact/:id/:financialYearId', component: ProfileContactFormComponent, data: { breadcrumb: "Edit Employee Contact Details" } },
          { path: 'view/:profileId/:financialYearId/:phaseId', component: TransferRequestViewComponent, data: { breadcrumb: "Edit Employee" } },
          { path: 'viewprofile/:profileId/:financialYearId', component: ViewEmployeeProfileComponent, data: { breadcrumb: "Edit Employee Profile" } },
          { path: 'transfer-requests', component: TransferRequestListComponent, data: { breadcrumb: "Transfer Requests" } },
          {
            path: 'service-book',
            data: { breadcrumb: "Service Book" },
            children: [
              { path: ':profileId/:financialYearId', component: ServiceBookListComponent, data: { breadcrumb: "Service Book" } },
              { path: 'present-place/:profileId/:financialYearId', component: PresentPlaceFormComponent, data: { breadcrumb: "Present Place" } },
              { path: 'new/:profileId/:financialYearId', component: ServiceBookFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:profileId/:id/:financialYearId', component: ServiceBookFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'allotment',
        data: { breadcrumb: "Allotment" },
        children: [
          { path: '', component: AllotmentListComponent, data: { breadcrumb: "Allotment List" } },
          { path: 'process', component: AllotmentProcessComponent, data: { breadcrumb: "Process" } },
          { path: 'export', component: ExportExcelComponent, data: { breadcrumb: "Excel Export" } },
          { path: 'edit/:profileId/:id', component: AllotmentFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
      {
        path: 'transfer-orders',
        data: { breadcrumb: "Transfer Orders" },
        children: [
          { path: '', component: TransferOrderListComponent, data: { breadcrumb: "Transfer Orders" } },
          { path: 'export', component: TransferOrderExportComponent, data: { breadcrumb: "Excel Export" } },
          { path: ':profileId', component: TransferOrderListComponent, data: { breadcrumb: "Transfer Orders" } },
          { path: 'new/:profileId', component: TransferOrderFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:profileId/:id', component: TransferOrderFormComponent, data: { breadcrumb: "Edit" } }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementRoutingModule { }
